
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-9e773f78\",\"scoped\":true,\"hasInlineConfig\":false}!autoprefixer-loader!less-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/iview-loader/index.js??ref--1-1!./place-order.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/iview-loader/index.js??ref--1-1!./place-order.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9e773f78\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/iview-loader/index.js??ref--1-1!./place-order.vue"),
  /* scopeId */
  "data-v-9e773f78",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins/workspace/yzs-prod/duckbillscm-web-prod/src/components/place-order/place-order.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] place-order.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9e773f78", Component.options)
  } else {
    hotAPI.reload("data-v-9e773f78", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/place-order/place-order.vue
// module id = 1338
// module chunks = 61